// Unpublished Work © 2022 Deere & Company

import t from 'tcomb';

export const PrivacyPolicy = t.struct({
    countryCode: t.String,
    locale: t.String,
    privacyURL: t.String
}, {
    defaultProps: {
        countryCode: '',
        locale: '',
        privacyURL: ''
    },
    name: 'PrivacyPolicy'
});
